import { ListItem } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { RoutineNavigationListItem_Routine$key } from "./__generated__/RoutineNavigationListItem_Routine.graphql";

export function RoutineNavigationListItem(props: {
  isFirst?: boolean;
  isLast?: boolean;
  onPress(): void;
  routine: RoutineNavigationListItem_Routine$key;
}) {
  const data = useFragment(
    graphql`
      fragment RoutineNavigationListItem_Routine on Routine {
        title
      }
    `,
    props.routine
  );

  return (
    <ListItem
      border="border-primary"
      onPress={props.onPress}
      isFirst={props.isFirst}
      isLast={props.isLast}
      right={<ListItem.NavArrow />}
    >
      <ListItem.Title>{data.title}</ListItem.Title>
    </ListItem>
  );
}
